export default __webpack_public_path__ + "images/cobalt-arrow-medium.png?5dd5545dc84490b5b4efc611cdb16cff";